module.exports = __webpack_public_path__ + "media/usecase_enterprise_01.034eb433.mp4";